import { Controller } from '@hotwired/stimulus'
import { polite } from 'helpers/live_region_helper'
import { tableSelectionChanged } from '../../../helpers/custom_events_helper'

const INTERACTIVE_ELEMENTS = 'a, button, input, label, select, textarea, [role="button"]'

export default class extends Controller {
  static targets = ['supercheckbox', 'rowCheckbox']

  navigate(event) {
    if (event.target.closest(INTERACTIVE_ELEMENTS)) return

    const row = event.target.closest('tr[data-row-url]')
    if (!row) return

    const url = row.dataset.rowUrl

    if (event.ctrlKey || event.metaKey) {
      window.open(url, '_blank')
    } else if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.href = url
    }
  }

  toggleRow(event) {
    const row = event.target.closest('tr')
    if (!row) return

    const selected = event.target.checked
    row.classList.toggle('table__row--selected', selected)
    this._updateSupercheckbox()
    this._fireSelectionChanged()

    const header = row.querySelector('th')
    if (header) {
      polite.setContent(`Row ${header.textContent.trim()} ${selected ? 'selected' : 'unselected'}`)
    }
  }

  toggleAll(event) {
    const checked = event.target.checked

    this.rowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
      const row = checkbox.closest('tr')
      if (row) row.classList.toggle('table__row--selected', checked)
    })

    this._fireSelectionChanged()
    polite.setContent(checked ? 'All rows selected' : 'All rows unselected')
  }

  get selectionData() {
    return this.rowCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => JSON.parse(checkbox.dataset.selectionValue))
  }

  addSelectionChangeListener(callback) {
    this.element.addEventListener('table:selectionChanged', callback)
  }

  _fireSelectionChanged() {
    tableSelectionChanged(this.element, { selection: this.selectionData })
  }

  _updateSupercheckbox() {
    if (!this.hasSupercheckboxTarget) return

    const total = this.rowCheckboxTargets.length
    const checked = this.rowCheckboxTargets.filter((cb) => cb.checked).length

    this.supercheckboxTarget.checked = total > 0 && checked === total
    this.supercheckboxTarget.setAttribute('aria-label', checked === total ? 'Unselect All' : 'Select All')
  }
}
